import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LandingInvestors.css";

export default function InvestorLandingPage() {
  const screenshots = [
    "/screen1.png",
    "/screen2.png",
    "/screen3.png",
    "/screen4.png",
    "/screen5.png",
  ];

  const [currentScreen, setCurrentScreen] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentScreen((prev) => (prev + 1) % screenshots.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [screenshots.length]);

  const goToRegister = () => {
    navigate("/register");
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: "smooth",
    });

    setMenuOpen(false);
  };

  return (
    <div className="landing investor-landing">

      {/* =========================
          NAVBAR
      ========================== */}
      <nav className={`navbar ${menuOpen ? "menu-is-open" : ""}`}>

        <div
          className="logo"
          onClick={() =>
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }
        >
          <img
            src="/logo-side-by-side.png"
            alt="Nessefy Logo"
            className="logo-img"
          />
        </div>

        <div className={`nav-links ${menuOpen ? "active" : ""}`}>

          <a href="#why" onClick={() => setMenuOpen(false)}>
            Why Nessefy
          </a>

          <a href="#how" onClick={() => setMenuOpen(false)}>
            How It Works
          </a>

          <a href="#community" onClick={() => setMenuOpen(false)}>
            Community
          </a>

        </div>

        <div className="nav-actions">

          <button
            className="nav-login"
            onClick={() => navigate("/login")}
          >
            Sign In
          </button>

          <button
            className="nav-btn"
            onClick={goToRegister}
          >
            Join Free
          </button>

          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

        </div>
      </nav>


      {/* =========================
          HERO
      ========================== */}
      <section className="hero investor-hero">

        <div className="hero-blob blob-1"></div>
        <div className="hero-blob blob-2"></div>
        <div className="hero-blob blob-3"></div>

        <div className="hero-content">

          <p className="hero-badge">
            💼 BUILT FOR PEOPLE WHO INVEST IN IDEAS
          </p>

          <h1>
            The Next Great
            <br />
            Opportunity
            <br />

            <span className="highlight">
              Is Waiting to Be Found.
            </span>
          </h1>

          <p>
            Discover ambitious founders, promising startups, innovative
            businesses and ideas worth investing in — all in one ecosystem.
          </p>

          <div className="hero-buttons">

            <button
              className="primary-btn"
              onClick={goToRegister}
            >
              💼 Find Your Next Investment
              <span className="button-arrow">→</span>
            </button>

            <button
              className="secondary-btn"
              onClick={() => scrollTo("how")}
            >
              See How It Works
            </button>

          </div>

          <div className="free-points">

            <span>
              <b>✓</b> 100% free to join
            </span>

            <span>
              <b>✓</b> Discover new opportunities
            </span>

            <span>
              <b>✓</b> Built for investors
            </span>

          </div>

        </div>


        {/* HERO VISUAL */}
        <div className="hero-card investor-hero-card">

          <div className="floating-mini-card mini-card-1">
            <h4>📈 New Opportunity</h4>
            <p>Discover businesses worth watching</p>
          </div>

          <div className="post-card investor-post-card">

            <div className="investment-network">

              <div className="investment-circle investment-one">
                🚀
              </div>

              <div className="investment-circle investment-two">
                💡
              </div>

              <div className="investment-circle investment-three">
                📊
              </div>

              <div className="investment-line investment-line-one"></div>
              <div className="investment-line investment-line-two"></div>
              <div className="investment-line investment-line-three"></div>

              <div className="investment-center">

                <img
                  src="/n-logo.png"
                  alt="Nessefy"
                />

              </div>

            </div>

            <div className="post-card-copy">

              <h3>
                Invest in Possibility.
              </h3>

              <p>
                Great investments start with discovering the right people,
                ideas and opportunities early.
              </p>

            </div>

          </div>

        </div>

      </section>


      {/* =========================
          FREE STRIP
      ========================== */}
      <section className="free-strip">

        <div className="free-strip-icon">
          ✓
        </div>

        <div>

          <strong>
            Joining Nessefy is completely free.
          </strong>

          <span>
            Create your investor profile, discover businesses and
            connect with founders. No subscription. No joining fee.
          </span>

        </div>

        <button onClick={goToRegister}>
          Join Free →
        </button>

      </section>


      {/* =========================
          SHOWCASE
      ========================== */}
      <section className="showcase">

        <div className="showcase-content">

          <span className="showcase-tag">
            DISCOVER OPPORTUNITIES
          </span>

          <h2>
            Stop looking
            <br />
            everywhere.
            <br />

            <span className="showcase-highlight">
              Start discovering smarter.
            </span>
          </h2>

          <p>
            Nessefy brings investors, founders, startups and businesses
            into one ecosystem. Discover new ventures, understand the
            people behind them and find opportunities that match your
            interests.
          </p>

          <div className="app-download-buttons">

  <a
    href="https://play.google.com/store/apps/details?id=com.niteshagarwal8290.nessefymobile"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./Google-Play-Icon.png"
      alt="Get it on Google Play"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>GET IT ON</small>
      <strong>Google Play</strong>
    </span>
  </a>


  <a
    href="YOUR_APP_STORE_LINK"
    target="_blank"
    rel="noopener noreferrer"
    className="app-store-button"
  >
    <img
      src="./App-Store.png"
      alt="Download on the App Store"
      className="app-store-icon"
    />

    <span className="app-store-text">
      <small>DOWNLOAD ON THE</small>
      <strong>App Store</strong>
    </span>
  </a>

</div>


          <div className="showcase-benefits">

            <div>

              <span>01</span>

              <strong>
                Discover
              </strong>

              <p>
                Find founders, startups and businesses with exciting
                potential.
              </p>

            </div>


            <div>

              <span>02</span>

              <strong>
                Evaluate
              </strong>

              <p>
                Learn about the people, ideas and businesses behind
                potential opportunities.
              </p>

            </div>


            <div>

              <span>03</span>

              <strong>
                Connect
              </strong>

              <p>
                Start conversations and explore opportunities directly.
              </p>

            </div>

          </div>

        </div>


        {/* PHONE */}

        <div className="phone-showcase">

          <div className="floating-ui ui-top-left">
            📈 Investment Opportunities
          </div>

          <div className="floating-ui ui-top-right">
            🚀 Discover Startups
          </div>

          <div className="floating-ui ui-bottom-left">
            💡 New Ideas
          </div>

          <div className="floating-ui ui-bottom-right">
            ✨ Free to Join
          </div>


          <div className="phone-frame">

            <div className="phone-notch"></div>

            <div className="phone-screen">

              <img
                key={currentScreen}
                src={screenshots[currentScreen]}
                alt="Nessefy App"
                className="phone-screenshot"
              />

            </div>

          </div>

        </div>

      </section>


      {/* =========================
          WHY SECTION
      ========================== */}
      <section
        id="why"
        className="features"
      >

        <div className="features-header">

          <span className="features-tag">
            WHY DISCOVER INVESTMENTS ON NESSEFY?
          </span>

          <h2>
            Great opportunities
            <br />
            start with discovery.
          </h2>

          <p>
            Finding promising opportunities shouldn't mean searching
            through endless platforms, networks and inboxes. Nessefy
            gives investors a place to discover people and businesses
            worth knowing.
          </p>

        </div>


        <div className="journey-container">

          <div className="journey-card">

            <div className="journey-step">
              01
            </div>

            <div className="journey-icon">
              🔎
            </div>

            <h3>
              Discover
            </h3>

            <p>
              Explore startups, businesses, founders and innovative
              ideas from across the ecosystem.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card featured-journey">

            <div className="journey-step">
              02
            </div>

            <div className="journey-icon">
              📊
            </div>

            <h3>
              Explore
            </h3>

            <p>
              Understand the opportunity, the people behind it and
              what makes the business worth watching.
            </p>

          </div>


          <div className="journey-arrow">
            →
          </div>


          <div className="journey-card">

            <div className="journey-step">
              03
            </div>

            <div className="journey-icon">
              🤝
            </div>

            <h3>
              Connect
            </h3>

            <p>
              Start meaningful conversations with founders and
              discover where the opportunity can go.
            </p>

          </div>

        </div>


        <div className="features-stats">

          <div>

            <h4>
              FREE
            </h4>

            <p>
              Join Nessefy
            </p>

          </div>


          <div>

            <h4>
              AI
            </h4>

            <p>
              Smarter discovery
            </p>

          </div>


          <div>

            <h4>
              1
            </h4>

            <p>
              Entrepreneur ecosystem
            </p>

          </div>

        </div>

      </section>


      {/* =========================
          HOW IT WORKS
      ========================== */}
      <section
        id="how"
        className="about"
      >

        <div className="about-content">

          <span className="about-tag">
            HOW IT WORKS
          </span>

          <h2>
            From
            <br />

            “What's worth investing in?”
            <br />

            to

            <span className="how-highlight">
              “Let's talk.”
            </span>
          </h2>

          <p>
            You don't need to know where the next opportunity will come
            from. Build your investor profile, tell Nessefy what interests
            you and start discovering people and businesses worth exploring.
          </p>


          <div className="about-points">

            <div>

              <h4>
                01 — Create your investor profile
              </h4>

              <p>
                Tell the ecosystem about your interests, experience,
                industries and the kinds of opportunities you are looking for.
              </p>

            </div>


            <div>

              <h4>
                02 — Discover opportunities
              </h4>

              <p>
                Explore founders, startups, businesses and ideas that
                align with your interests.
              </p>

            </div>


            <div>

              <h4>
                03 — Start the conversation
              </h4>

              <p>
                Connect with founders, ask questions and explore whether
                there is an opportunity worth pursuing.
              </p>

            </div>

          </div>

        </div>


        {/* ORBIT */}

        <div className="about-visual">

          <div className="orbit-card about-card-1">
            Startup
          </div>

          <div className="orbit-card about-card-2">
            Founder
          </div>

          <div className="orbit-card about-card-3">
            Business
          </div>

          <div className="orbit-card about-card-4">
            Opportunity
          </div>

          <div className="orbit-card about-card-5">
            Innovation
          </div>


          <div className="about-center-card investor-center-card">

            <img
              src="/n-logo.png"
              alt="Nessefy Logo"
            />

            <h3>
              Discover Potential
            </h3>

            <p>
              People • Ideas • Opportunities
            </p>

          </div>

        </div>

      </section>


      {/* =========================
          COMMUNITY
      ========================== */}
      <section
        id="community"
        className="community-section"
      >

        <div className="community-content">

          <span className="community-tag">
            AN ECOSYSTEM OF OPPORTUNITY
          </span>

          <h2>
            The next opportunity
            <br />
            could be closer than you think.
          </h2>

          <p>
            Nessefy brings together investors, entrepreneurs, founders,
            startups, freelancers and professionals who are building
            the businesses of tomorrow.
          </p>


          <div className="community-people">

            <div className="community-avatar">
              👨🏻‍💼
            </div>

            <div className="community-avatar">
              👩🏻‍💼
            </div>

            <div className="community-avatar">
              👨🏽‍🚀
            </div>

            <div className="community-avatar">
              👩🏽‍💻
            </div>

            <div className="community-avatar">
              👨🏻‍💡
            </div>

            <div className="community-count">
              +
            </div>

          </div>


          <div className="community-labels">

            <span>
              Investors
            </span>

            <span>
              Founders
            </span>

            <span>
              Startups
            </span>

            <span>
              Entrepreneurs
            </span>

            <span>
              Businesses
            </span>

          </div>

        </div>

      </section>


      {/* =========================
          FINAL CTA
      ========================== */}
      <section className="contact-section final-investor-cta">

        <div className="contact-content">

          <span className="contact-tag">
            YOUR NEXT OPPORTUNITY
          </span>

          <h2>
            Stop searching
            <br />
            for opportunities
            <br />
            everywhere.
          </h2>

          <h3>
            Start discovering on
            <span>
              Nessefy.
            </span>
          </h3>

          <p>
            Join for free. Create your investor profile.
            Start discovering founders, businesses and ideas
            that could become your next opportunity.
          </p>


          <button
            className="primary-btn final-cta-button"
            onClick={goToRegister}
          >
            💼 Discover Opportunities
            <span>
              — It's Free
            </span>
          </button>


          <div className="final-free-line">

            ✓ Free to join

            <span>
              •
            </span>

            ✓ No credit card

            <span>
              •
            </span>

            ✓ Takes less than 2 minutes

          </div>

        </div>


        {/* FINAL CARD */}

        <div className="contact-card final-free-card">

          <div className="free-card-icon">
            ✓
          </div>

          <span>
            NO CATCH.
          </span>

          <h3>
            Nessefy is
            <br />

            <strong>
              100% FREE
            </strong>

            <br />

            to join.
          </h3>

          <p>
            Create your investor profile and start
            discovering people and opportunities worth knowing.
          </p>


          <button
            onClick={goToRegister}
            className="free-card-button"
          >
            Create My Free Profile →
          </button>

        </div>

      </section>


      {/* =========================
          FOOTER
      ========================== */}
      <footer className="footer">

        <p>
          © 2026 Nessefy. All rights reserved.
        </p>

        <div className="footer-links">

          <span
            onClick={() => navigate("/privacy-policy")}
          >
            Privacy Policy
          </span>

          <span
            onClick={() => navigate("/terms-and-conditions")}
          >
            Terms & Conditions
          </span>

        </div>

      </footer>

    </div>
  );
}